import { useState } from "react"
import { Button } from "~/components/reusable/Button"
import { Popover, PopoverContent, PopoverTrigger } from "~/components/reusable/Popover"
import { cn } from "~/utils/helpers"
import { Filter, type FilterFieldType } from "~/utils/filter"
import type { FilterFieldGroup } from "./FilterFieldGroupList"
import { FilterGroupEditor } from "./FilterGroupEditor"

interface FilterListPopoverProps {
  filters: Filter[]
  onFiltersChange: (filters: Filter[]) => void
  trigger?: React.ReactNode
  isLocal?: boolean
  align?: "start" | "center" | "end"
  customFilterFields?: FilterFieldType[]
  customFilterFieldOptions?: { label: string; value: string | undefined }[]
  extraFilterFields?: FilterFieldType[]
  fieldGroups?: FilterFieldGroup[]
}

export function FilterListPopover({
  filters,
  onFiltersChange,
  isLocal = false,
  trigger,
  align = "start",
  customFilterFields,
  customFilterFieldOptions,
  extraFilterFields,
  fieldGroups,
}: FilterListPopoverProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const defaultTrigger = (
    <Button size="sm" variant="neutral">
      Show {filters.length} more
    </Button>
  )

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger asChild>{trigger ?? defaultTrigger}</PopoverTrigger>
      <PopoverContent
        className={cn("min-w-[300px] rounded-[12px] p-0 overflow-hidden w-fit")}
        align={align}
        sideOffset={8}
      >
        <FilterGroupEditor
          filters={filters}
          onFiltersChange={onFiltersChange}
          isLocal={isLocal}
          customFilterFields={customFilterFields}
          customFilterFieldOptions={customFilterFieldOptions}
          extraFilterFields={extraFilterFields}
          fieldGroups={fieldGroups}
          enableGroups={false}
        />
      </PopoverContent>
    </Popover>
  )
}
